<div class="preview-bar">
	<div class="preview-bar-label">
		<i class="wq wq-eye"></i>
		<span class="preview-bar-tag">Preview</span>
	</div>

	<div class="preview-bar-controls">
		<label class="preview-bar-field">
			<span class="preview-bar-field-label">Viewing as</span>
			<!--
				ngModel rather than [value]: a plain [value] on a <select> is applied before its *ngFor
				options exist, so the browser discards it and the box drops back to the first option.
				ngValue also keeps the ids as numbers instead of stringifying them.
			-->
			<select class="preview-bar-select"
				[ngModel]="roleId"
				[disabled]="preview.switching"
				[attr.title]="preview.switching ? 'Switching role…' : null"
				(ngModelChange)="onRoleChange($event)">
				<option [ngValue]="null">Unrestricted</option>
				<option *ngFor="let role of preview.roles" [ngValue]="role.id">{{ role.name }}</option>
			</select>
		</label>

		<span class="preview-bar-spinner" *ngIf="preview.switching">
			<i class="wq wq-refresh"></i> Switching…
		</span>
	</div>

	<div class="preview-bar-meta">
		<span class="preview-bar-note" *ngIf="note">{{ note }}</span>
		<span class="preview-bar-readonly">Read-only</span>
	</div>
</div>
